import { render } from "./Aside.vue?vue&type=template&id=60c919be&scoped=true&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import "./Aside.vue?vue&type=style&index=0&id=60c919be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c919be"],['__file',"src/components/aside/Aside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60c919be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60c919be', __exports__)) {
    api.reload('60c919be', __exports__)
  }
  
  module.hot.accept("./Aside.vue?vue&type=template&id=60c919be&scoped=true&ts=true", () => {
    api.rerender('60c919be', render)
  })

}


export default __exports__